<template>
  <div>
    <!--
      <Summary :inquiry="inquiry" :extras="extras" :locale="$i18n.locale" :params="staticParams"></Summary>
  -->
    <Alert>{{ $t('static_translation.bitte-uberprufen-sie-ihre-daten') }}</Alert>
    <h4>{{ $t('static_translation.reisedaten') }}</h4>
    <dl class="uk-description-list-horizontal">
      <dt>{{ $t('static_translation.an-und-abreise') }}</dt>
      <dd>
        {{ inquiry.arrival_at | localizedDate(locale) }} - {{ inquiry.departure_at | localizedDate(locale) }}
      </dd>
      <dt>{{ $t('static_translation.anzahl-der-personen') }}</dt>
      <dd>
        {{ inquiry.adults }} {{ $t('static_translation.erwachsene') }},
        {{ inquiry.childs }} {{ $t('static_translation.kinder') }}
        ({{ $t('static_translation.alter-der-kinder') }}: {{ inquiry.age_of_childs }})
      </dd>
    </dl>
    <h4>{{ $t('static_translation.kontaktdaten') }}</h4>
    <div >
      <dl class="uk-description-list-horizontal ">
        <dt>{{ $t('static_translation.name') }}</dt>
        <dd>
          {{ salutation }} {{ inquiry.first_name }} {{ inquiry.last_name }}
        </dd>
        <dt>{{ $t('static_translation.e-mail') }}</dt>
        <dd>
          {{ inquiry.mail }}
        </dd>
      </dl>
      <dl class="uk-description-list-horizontal">
        <template v-if="inquiry.street">
          <dt>{{ $t('static_translation.strasse') }}</dt>
          <dd>
            {{ inquiry.street }}
          </dd>
        </template>
        <dt>{{ $t('static_translation.plz-ort') }}</dt>
        <dd>
          {{ inquiry.zip }} {{ inquiry.city }}
        </dd>
        <dt>{{ $t('static_translation.land') }}</dt>
        <dd>
          {{ country }}
        </dd>
      </dl>
      <dl
        v-if="inquiry.phone"
        class="uk-description-list-horizontal">
        <dt>{{ $t('static_translation.telefon') }}</dt>
        <dd>
          {{ inquiry.phone }}
        </dd>
      </dl>
    </div>
    <div v-if="inquiry.type === 3">
      <h4>{{ $t('static_translation.details') }}</h4>
      <Extras :is-editor="false" />
    </div>

    <h4>{{ $t('static_translation.nachricht') }}</h4>
    <dl
      v-if="inquiry.message"
      class="uk-description-list ">
      <dt>{{ $t('static_translation.nachricht-an-den-vermieter') }}</dt>
      <dd>
        {{ inquiry.message || 'keine Nachricht' }}
      </dd>
    </dl>
    <div v-else>Keine Nachricht</div>

    <div v-if="inquiry.is_late_exchange!=1">
      <dl v-if="inquiry.type==3 || (inquiry.type==1 && inquiry.pool_id)">

        <dt>{{ $t('static_translation.bitte-geben-sie-meine-anfrage-an-andere-vermieter-weiter-wenn-sie-keine-freien-kapazitaten-mehr-haben') }}</dt>
        <dd>
          <span v-if="inquiry.is_exchange">{{ $t('static_translation.ja') }}</span><span v-else>{{ $t('static_translation.nein') }}</span>
        </dd>
      </dl>

      <dl>
        <dt>{{ $t('static_translation.daten-im-browser-fuer-aehnliche-anfrage-sichern') }}</dt>
        <dd>
          <span v-if="saveInBrowser">{{ $t('static_translation.ja') }}</span><span v-else>{{ $t('static_translation.nein') }}</span>
        </dd>
      </dl>
    </div>
    <div v-if="inquiry.is_late_exchange">
      <h4>{{ $t('static_translation.zustimmung-zur-datenverarbeitung') }}</h4>
      <div
        v-if="!GDPR && !isPristine"
        class="uk-text-danger uk-text-bold blink-1"
        style="padding-top: 6px;"
      >
        <Alert
          type="error"
          style="font-size: 13px;"
        >
          {{ $t('static_translation.bitte-stimmen-sie-der-datenverarbeitung-zu-um-fortzufahren') }}
        </Alert>
      </div>
      <FormItem>
        <Checkbox v-model="GDPR">
          <span class="checkboxes gdpr">
            {{ $t('static_translation.zustimmung-weitergabe') }}
            (<a
              href="https://www.tourismusnetz.at/datenschutzverordnung-dsgvo"
              target="_blank"
            >
              {{ $t('static_translation.datenschutzerklaerung') }}
            </a>)
          </span>
        </Checkbox>
      </FormItem>
    </div>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import ParamCheckboxes from './ParamCheckboxes'
import Extras from './Extras'
import sugar from 'sugar'
import 'sugar/locales'
import _ from 'lodash'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'Summary',
  components: {
    ParamCheckboxes,
    Extras
  },
  filters: {
    localizedDate: (value, locale) => {
      const newDate = sugar.Date.create(value)
      sugar.Date.setLocale(locale || 'de')
      return sugar.Date.short(newDate)
    }
  },
  data () {
    return {
      isPristine: true,
      isValidate: false
    }
  },
  computed: {
    ...mapFields([
      'inquiry.GDPR'
    ]),
    ...mapState({
      lodgings: state => state.store.lodgings,
      countries: state => state.store.countries,
      inquiry: state => state.store.inquiry,
      saveInBrowser: state => state.store.saveInBrowser,
      locale: state => state.store.locale,
      places: state => state.store.places,
      types: state => state.store.types,
      regions: state => state.store.regions,
      extras: state => state.store.extras
    }),
    salutation () {
      return this.$t('salutation.' + this.inquiry.salutation_id)
    },
    country () {
      const index = _.findIndex(this.countries, { id: this.inquiry.country_id })
      if (index >= 0) {
        const country = this.countries[index]
        return (this.locale === 'de') ? country.name : country.name_en
      }
    }
  },
  mounted () {
    this.$bus.$on('validate-data', async (page) => {
      this.isPristine = false
      if (page === 'Summary') {
        if (this.GDPR) {
          this.isPristine = true
          this.$emit('on-validated', 'Summary')
        } else {
          this.validated = false
        }
      }
    })
  }
}
</script>

<style>
.uk-description-list-horizontal {
    overflow: hidden;
  }
  .uk-description-list-horizontal > dt {
    width: 160px;
    float: left;
    clear: both;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .uk-description-list-horizontal > dd {
    margin-left: 180px;
  }
  dl dt {
    color: #777777;
  }
</style>
